<template>
  <v-container fluid class="white content-wrapper">
    <v-container grid-list-lg>
      <v-layout column>
        <v-flex
          class="display-2 font-weight-black heading--text text-center text-xs-center my-5"
          >Sign-up for Upload 2020
        </v-flex>
        <v-flex>
          <div
            class="headline mt-3 black--text darken-3 text-center font-weight-bold"
          >
            <p>
              Please use the form below to signup for Upload 2020...
            </p>
          </div>
          <iframe
            id="signup"
            src="https://docs.google.com/forms/d/e/1FAIpQLSdh57m8LwfKVP5UI4oTZm-xRYncyUkDz4jNP3q2zFAkMAZADg/viewform?usp=sf_link"
            width="100%"
            height="2612"
            frameborder="0"
            marginheight="0"
            marginwidth="0"
            black
            >Loading…
          </iframe>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: 'signup',
  data() {
    return {};
  }
};
</script>

<style scoped>
.content-wrapper {
  margin-top: -10px;
  font-family: 'Lato', sans-serif;
  text-transform: uppercase;
}

.heading--text {
  color: #ff914d;
}

h1 {
  font-size: 20px;
}

video {
  width: 100%;
  height: auto;
}
</style>
